export type SessionMode = 'equanaut' | 'command-center' | 'task';

export function resolveEquanautSessionKey(
  organizationId?: string,
  mode: SessionMode = 'equanaut',
  taskId?: string,
  explicitKey?: string,
): string | undefined {
  if (explicitKey) return explicitKey;
  if (mode === 'task' && taskId) return `task:${taskId}`;
  if (mode === 'command-center') return 'agent:main:main';
  if (organizationId) return `agent:main:equa-${organizationId}`;
  return 'agent:main:main';
}
